import { render } from "./FeedbackMessage.vue?vue&type=template&id=676cd597&scoped=true"
import script from "./FeedbackMessage.vue?vue&type=script&lang=js"
export * from "./FeedbackMessage.vue?vue&type=script&lang=js"

import "./FeedbackMessage.vue?vue&type=style&index=0&id=676cd597&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676cd597"]])

export default __exports__